import React from 'react';
import { useStateManager, DisabledPrompt,Link } from "bcms-react";
import { LayoutContainer, LeftColumnContainer, RightColumnContainer, TableBody, TableItemContainer, TableItemView, TableView} from 'components/shared';
import { UICheckbox } from 'components/ui';
import { SVGAsset } from 'res';
import "./styles.css";
import "./mobile.css";
import NoFilesToDisplayTableRow from '../NoFilesToDisplayTableRow';

/**
 * @function MobileHistoryACHPassThruTable
 * @param {String} className - Allows us to set a custom class name for the component
 * @return {React.Component}
 * @exported true
 * @description The mobile history ACH Pass Thru Table
 */

export default function MobileHistoryACHPassThruTable(props) {
  const { history } = props.data ?? {}
  const { onSelectAllCheckmarksChange, allRowsAreChecked } = props.actions ?? {};

  const hasHistory = history.length > 0;

  const historyRows = history.reduce((acc, item) => {
    acc.push(<MobileHistoryACHPassThruItem key={item.id} data={item} />);
    return acc;
  }, []);

  return (

    <TableView className="mobile-history-ach-pass-thru-table">
      <thead>
        <tr className="table-column-container" >
          <th colSpan="4"><UICheckbox label="" value={allRowsAreChecked} onChange={onSelectAllCheckmarksChange} /></th>
        </tr>
      </thead>
      <TableBody>
        {hasHistory && historyRows}
        {!hasHistory && <NoFilesToDisplayTableRow colSpan="6" />}
      </TableBody>
    </TableView>

  );
}

/**
 * @function MobileHistoryACHPassThruItem
 * @return {React.Component}
 * @exported false
 * @description The table item for the MobileHistoryACHPassThruItem 
 */

function MobileHistoryACHPassThruItem(props) {
  const { onRowChecked } = useStateManager();
  const data = props.data ?? {};

  return (
    <TableItemContainer>
      <TableItemView>
        <UICheckbox className="item-row-checkbox" label="" value={data.isChecked} onChange={onRowChecked(data.id)} />
      </TableItemView>
      <TableItemView className="data-column">
        <LayoutContainer>
          <LeftColumnContainer>
            <div className="table-item-title"><b>Created By:</b></div>
          </LeftColumnContainer>
          <RightColumnContainer>
            <div className="table-item-detail text-right"><p>{data.createdBy}</p></div>
          </RightColumnContainer>
        </LayoutContainer>
        <LayoutContainer>
          <LeftColumnContainer>
            <div className="table-item-title">Updated:</div>
          </LeftColumnContainer>
          <RightColumnContainer>
            <div className="table-item-detail text-right"><p>{data.updatedDate.format()}</p></div>
          </RightColumnContainer>
        </LayoutContainer>
        <LayoutContainer>
          <LeftColumnContainer>
            <div className="table-item-title">Status:</div>
          </LeftColumnContainer>
          <RightColumnContainer>
            <div className="table-item-detail text-right"><p> {data.status}</p></div>
          </RightColumnContainer>
        </LayoutContainer>
        <LayoutContainer>
          <LeftColumnContainer>
            <div className="table-item-title">File Name:</div>
          </LeftColumnContainer>
          <RightColumnContainer>
            <DisabledPrompt>
              <Link className="table-item-detail text-right link clickable"><p>{data.fileName}</p></Link>
            </DisabledPrompt>
          </RightColumnContainer>
        </LayoutContainer>
   
      </TableItemView>
  
    </TableItemContainer>
  );
}